import { Link, useLocation } from "react-router-dom";
import { Notice } from "../../ui";
import { useNextT } from "../../i18n";
import { rich } from "../../contacts/components/dialogs";
import { useAccess, useCan } from "../api";
import s from "./Notices.module.scss";

/**
 * Boards 71 G/H and 94: "This account is view-only right now." Everyone reads who to contact (the owner's name, no
 * reason, no payment details). A person who may see billing reads why instead, with "Go to billing". Nothing while the
 * account is not view-only or the answer is still loading.
 */
export const ViewOnlyNotice = () => {
  const { t } = useNextT();
  const access = useAccess().data;
  const seesBilling = useCan("billing.view");
  const { pathname } = useLocation();
  // The locked-account page says it itself (its heading and the holder's details): not twice (walkthrough public #7).
  if (!access?.viewOnly.active || pathname === "/help/contact") return null;
  const owner = access.workspace.owner?.name;
  // The reason text is the contact-limit one only for that reason; a locked account (trial over, payment failed...) gets its own.
  const overLimit = access.viewOnly.reason === "over_contact_limit" || access.viewOnly.reason === "over_plan";
  const second = seesBilling
    ? t(overLimit ? "access.view_only.reason" : "access.view_only.reason_locked")
    : owner ? rich(t, "access.view_only.contact", {}, { name: <bdi>{owner}</bdi> }) : t("access.view_only.contact_unknown");
  return (
    <Notice tone="warning" action={seesBilling ? <Link to="/billing" className={s.link}>{t("access.view_only.billing")}</Link> : undefined}>
      <p className={s.sentence}>{t("access.view_only.title")} {second}</p>
    </Notice>
  );
};
